"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useJira_1 = __importDefault(require("hooks/useJira"));
const HelperUtils_1 = require("utils/HelperUtils");
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const Avatar_1 = __importDefault(require("components/shared/Avatar"));
const RadioButton_1 = __importDefault(require("components/shared/RadioButton"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const SetParagraph = ({ isDisabled, text = '', customClass }) => {
    return (react_1.default.createElement(TruncateParagraph_1.default, { position: "bottom", className: `typography-paragraph ${isDisabled ? 'text-n-700' : 'text-n-900'} ${customClass}`, align: "left" }, text));
};
const SetRadioButton = ({ jira }) => {
    const selectedJIRA = (0, useJira_1.default)((state) => state.selectedJIRA);
    const setSelectedJIRA = (0, useJira_1.default)((state) => state.setSelectedJIRA);
    return (react_1.default.createElement(RadioButton_1.default, { name: `connect-jira-data-${jira?.data?.id}`, checked: selectedJIRA?.data?.id == jira?.data?.id, onClick: (e) => {
            e?.stopPropagation();
            setSelectedJIRA(jira);
        } }));
};
const RowJira = ({ jira, isShowChildIssue }) => {
    const selectedData = (0, useJira_1.default)((state) => state.selectedData);
    const setSelectedJIRA = (0, useJira_1.default)((state) => state.setSelectedJIRA);
    const isJiraLinked = (0, react_1.useMemo)(() => jira?.state == 'linked', [jira?.state]);
    const isAbleToLink = (0, react_1.useMemo)(() => jira?.ableToLink == true, [jira?.ableToLink]);
    const dataProject = (0, react_1.useMemo)(() => jira?.data, [jira]);
    const dataIssue = (0, react_1.useMemo)(() => jira?.data, [jira]);
    const isProjectSelected = (0, react_1.useMemo)(() => selectedData == 'project', [selectedData]);
    const isRowDisabled = isJiraLinked || !isAbleToLink;
    return (react_1.default.createElement(Table_1.default.Row, { useOverflowTable: false, useRowHover: !isRowDisabled, customClass: `${isRowDisabled ? 'bg-n-200' : ''} !h-[52px]`, onClick: () => !isRowDisabled && setSelectedJIRA(jira), key: `tooltip-${jira?.data?.id}`, tooltip: {
            show: isRowDisabled,
            text: (0, HelperUtils_1.getObjectiveLocale)(!isAbleToLink
                ? `You do not have permission to import this ${jira?.integrationType}`
                : `This ${jira?.integrationType} has been linked with other Goal/Project/Task`)
        } },
        !isShowChildIssue && (react_1.default.createElement(Table_1.default.Column, { heightClass: "h-[52px]", key: "no" }, !isRowDisabled && react_1.default.createElement(SetRadioButton, { jira: jira }))),
        react_1.default.createElement(Table_1.default.Column, { heightClass: "h-[52px]", key: "picture" },
            react_1.default.createElement(AWSImage_1.default, { src: isProjectSelected
                    ? dataProject?.avatarUrls?.['24x24']
                    : dataIssue?.fields?.issuetype?.iconUrl, className: `rounded-[4px] w-[32px] h-[32px] mr-[16px] ${isRowDisabled ? 'opacity-50' : ''}` }),
            react_1.default.createElement("div", { className: "w-[calc(100%-48px)]", key: "name" },
                react_1.default.createElement(SetParagraph, { isDisabled: isRowDisabled, text: isProjectSelected ? dataProject?.name : dataIssue?.fields?.summary }))),
        react_1.default.createElement(Table_1.default.Column, { heightClass: "h-[52px]", key: "key" },
            react_1.default.createElement(SetParagraph, { isDisabled: isRowDisabled, text: jira?.data?.key })),
        react_1.default.createElement(Table_1.default.Column, { heightClass: "h-[52px]", key: "type" },
            react_1.default.createElement(SetParagraph, { isDisabled: isRowDisabled, text: isProjectSelected
                    ? dataProject?.styleName
                    : dataIssue?.fields?.issuetype?.name })),
        react_1.default.createElement(Table_1.default.Column, { heightClass: "h-[52px]", key: "assignee" },
            react_1.default.createElement(Avatar_1.default, { src: (isProjectSelected
                    ? dataProject?.lead?.avatarUrls?.['24x24']
                    : dataIssue?.fields?.assignee?.avatarUrls?.['24x24']) || '', name: (isProjectSelected
                    ? dataProject?.lead?.displayName
                    : dataIssue?.fields?.assignee?.displayName) || '', size: 24, className: isRowDisabled ? 'opacity-50' : '' }),
            react_1.default.createElement(SetParagraph, { isDisabled: isRowDisabled, customClass: "ml-[16px]", text: isProjectSelected
                    ? dataProject?.lead?.displayName
                    : dataIssue?.fields?.assignee?.displayName }))));
};
exports.default = RowJira;
